<div class="conatiner-fluid p-4 pb-5">
    <!-- <div class="d-flex align-items-center mb-4">
      <button (click)="close()" class="back-btn me-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </button>
      <h1 class="page-title m-0">Update Requirement</h1>
    </div>
   -->
    <!-- TOP CARD: Product Info -->
    <div class="product-info-card card border-0 shadow-sm mb-4 p-4" style="border-radius: 12px;">
      <div class="row align-items-center">
        <!-- left image -->
        <div class="col-md-3 text-center img-card">
          @if(article.articleImage){
            <img [src]="articleImage" class="img-fluid rounded product-img" alt="Product Image" />
          }@else{
            <img src="assets/images/fruits_dummy.png" class="img-fluid rounded product-img" alt="Product Image" />
          }
        </div>
        <!-- right info -->
        <div class="col-md-9 product-details">
          <div class="d-flex align-items-center mb-2">
            <!-- <span class="badge badge-booking me-2 fw-bold">PRE-BOOKING</span> -->
            <span class="ref-tag">#{{ data.displayId | uppercase }}</span>
          </div>
          <h2 class="product-title mb-1">
            {{ article.article }} {{ article.variety ? '- ' + article.variety : '' }}
          </h2>
          <div class="origin-info mb-3 d-flex align-items-center">
             <img *ngIf="article.origin" [src]="getCountryFlag(article.origin)"
                            class="country-flag" alt="" style="width: 16px; height: 16px; margin-right: 6px;border-radius: 4px;">
            
            <span class="text-muted" style="font-size: 13px;">Origin: {{ article.origin }}</span>
          </div>
        

          <div class="specs-grid d-flex gap-3 mb-4">
            <div class="spec-box flex-fill">
               <div class="spec-label">SIZE</div>
               <div class="spec-val">{{ article.specification || '--' }}</div>
            </div>
            <div class="spec-box flex-fill">
               <div class="spec-label">PACK</div>
               <div class="spec-val">{{ article.packaging || '--' }}</div>
            </div>
            <div class="spec-box flex-fill">
               <div class="spec-label">GRADE</div>
               <div class="spec-val">{{ article.grade || 'Class 1' }}</div>
            </div>
          </div>

          <!-- Quality Guarantee -->
          <div class="quality-guarantee d-flex align-items-center gap-2 mt-3 p-2 px-3">
            <i class="bi bi-info-circle-fill text-primary"></i>
            <div>
              <strong>Quality Guarantee</strong>
              <p class="m-0">All produce is inspected and certified. Cold chain maintained throughout delivery.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- BOTTOM CARD: Form Details -->
    <div class="quote-form-card card border-0 shadow-sm p-4 pb-5 mb-5" style="border-radius: 12px;">
      <div class="form-header mb-4">
        <h3 class="form-title m-0">Update Request Details</h3>
        <p class="form-subtitle mt-1 mb-0" style="font-size: 14px;">Fill in the details below to receive a customized quote</p>
      </div>

      <form [formGroup]="createRequirement" (ngSubmit)="submitRequirement()">
        <div class="row">
          
          <!-- Quantity & UOM -->
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['quantity'].invalid}">
                <label for="quantity">Quantity <span class="text-danger">*</span></label>
                <input matInput type="number" placeholder="Enter quantity" formControlName="quantity" id="quantity" (wheel)="$event.target.blur()"/>
             </div>
          </div>
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['uom'].invalid}">
                <label for="uom">Unit of Measure <span class="text-danger">*</span></label>
                <mat-select placeholder="Select UOM" formControlName="uom" id="uom">
                  @for(uom of uomDropDown;track $index){
                    <mat-option [value]="uom">{{uom}}</mat-option>
                  }
                </mat-select>
             </div>
          </div>

          <!-- Incoterms & Currency -->
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['incoterms'].invalid}">
                <label for="incoterms">Incoterms <span class="text-danger">*</span></label>
                <mat-select placeholder="Select Incoterms" formControlName="incoterms" id="incoterms">
                  @for(incoterms of incoterms;track $index){
                    <mat-option [value]="incoterms">{{incoterms}}</mat-option>
                  }
                </mat-select>
             </div>
          </div>
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['currency'].invalid}">
                <label for="currency">Currency <span class="text-danger">*</span></label>
                <mat-select placeholder="Select Currency" formControlName="currency" id="currency">
                  @for(currency of currency;track $index){
                    <mat-option [value]="currency">{{currency}}</mat-option>
                  }
                </mat-select>
             </div>
          </div>

          <!-- Unit Price & Total Price -->
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['buyingPrice'].invalid}">
                <label for="buyingPrice">Unit Price</label>
                <input matInput type="number" placeholder="Enter unit price" formControlName="buyingPrice" id="buyingPrice" (wheel)="$event.target.blur()" />
             </div>
          </div>
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['totalPrice'].invalid}">
                <label for="totalPrice">Total Price</label>
                <input matInput type="text" placeholder="Auto calculated" formControlName="totalPrice" 
                  [value]="createRequirement.value.currency + ' ' + (createRequirement.value?.quantity * createRequirement.value?.buyingPrice)"
                  id="totalPrice" readonly="true" />
             </div>
          </div>

          <!-- Route & Long Term Contract -->
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['route'].invalid}">
                <label for="route">Route <span class="text-danger">*</span></label>
                <mat-select placeholder="Select Route" formControlName="route" id="route">
                  @for(route of routeList;track $index){
                    <mat-option [value]="route">{{route}}</mat-option>
                  }
                </mat-select>
             </div>
          </div>
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['longTermContract'].invalid}">
                <label for="longTermContract">Long Term Contract <span class="text-danger">*</span></label>
                <mat-select placeholder="Select Option" formControlName="longTermContract" id="longTermContract" (selectionChange)="setLongTermContractToggleValue()">
                  <mat-option [value]="true">Yes</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
             </div>
          </div>

          <!-- Periodicity & Shipment Quantity -->
          <!-- Note: They are shown full width logically in the image if available or inline. The image shows them 50/50. -->
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['periodicity'].invalid}">
                <label for="periodicity">Periodicity <span class="text-danger" *ngIf="createRequirement.value.longTermContract">*</span></label>
                <mat-select placeholder="Select Periodicity" formControlName="periodicity" [disabled]="!createRequirement.value.longTermContract">
                  <mat-option value="weekly">Weekly</mat-option>
                  <mat-option value="monthly">Monthly</mat-option>
                  <mat-option value="season">Season</mat-option>
                </mat-select>
             </div>
          </div>
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['shipmentQuantity'].invalid}">
                <label for="shipmentQuantity">Shipment Quantity <span class="text-danger" *ngIf="createRequirement.value.longTermContract">*</span></label>
                <input matInput type="number" placeholder="Enter shipment quantity" formControlName="shipmentQuantity" id="shipmentQuantity" [readonly]="!createRequirement.value.longTermContract" (wheel)="$event.target.blur()"/>
             </div>
          </div>

          <!-- ETA & [Empty] -->
          <div class="col-md-6 mb-3">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['eta'].invalid}">
                <label for="eta">Expected Time of Arrival (ETA) <span class="text-danger">*</span></label>
                <input matInput type="date" placeholder="mm/dd/yyyy" formControlName="eta" id="eta" #dateInput (click)="dateInput.showPicker()"/>
             </div>
          </div>
          <!-- Hidden destination port so nothing breaks but it wasn't strictly in the visual grid of the image -> maybe they want to keep it or hide it? The user said "keep the existing fields only just the format and placement ... should be how it is mentioned in the image". Let's put Destination in the empty column. -->
          <div class="col-md-6 mb-3">
            <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['destinationPort'].invalid}">
               <label for="destinationPort">Destination Port</label>
               <input matInput type="text" placeholder="Enter destination" formControlName="destinationPort" id="destinationPort" [readonly]="true" />
            </div>
         </div>

          <!-- Process Notes -->
          <div class="col-12 mb-4 mt-2">
             <div class="custom-form-field" [ngClass]="{'invalid-field': submitted && createRequirement.controls['processNote'].invalid}">
                <label for="processNote">Process Notes</label>
                <textarea matInput rows="4" placeholder="Add any special requirements or notes..." formControlName="processNote" id="processNote" style="width:100%; border:1px solid #e2e8f0; border-radius:8px; padding:12px; outline:none; resize:none; font-family:'Inter', sans-serif;"></textarea>
             </div>
          </div>

        </div>
  
        <div class="d-flex flex-column-reverse flex-md-row justify-content-end gap-3 mt-4">
          <button type="button" class="btn btn-link " style="text-decoration: none; font-weight: 500;color:#6B7280" (click)="close()">
            Cancel
          </button>
          <button type="submit" class="btn submit-btn" style="background-color: #1E1B4B; color: white; border: none; font-weight: 500; padding: 10px 24px; border-radius: 8px;">
            Update Requirement
          </button>
        </div>
      </form>
    </div>

    <!-- Dialog -->
    <div #modal class="modal" id="modal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header text-center">
            <h5 class="modal-title text-center" style="font-size: 1.4rem">{{ modalTitle }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ modalText }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  